import { render, staticRenderFns } from "./actionForm.vue?vue&type=template&id=6857c4d0"
import script from "./actionForm.vue?vue&type=script&lang=js"
export * from "./actionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports